export const HistorySectionType = {
  MEDICAL: 1,
  FAMILY: 2,
  SOCIAL: 3,
  SURGICAL: 4,
  HOSPITAL: 5,
};

export const MedicalHistoryCategory = {
  HEAD: 1,
  EYES: 2,
  EARS: 3,
  NOSE: 4,
  MOUTH: 5,
  CARDIO: 6,
  RESPI: 7,
  GASTRO: 8,
  GENI: 9,
  ENDO: 10,
  HEME: 11,
  INFECT: 12,
  MUSCU: 13,
  SKIN: 14,
  NEURO: 15,
  PSYCH: 16,
  NONE: 17,
  CUSTOM: 18,

  properties: {
    1: { name: 'Head', value: 1 },
    2: { name: 'Eyes', value: 2 },
    3: { name: 'Ears', value: 3 },
    4: { name: 'Nose/Sinuses', value: 4 },
    5: { name: 'Mouth/Throat/Teeth', value: 5 },
    6: { name: 'Cardiovascular', value: 6 },
    7: { name: 'Respiratory', value: 7 },
    8: { name: 'Gastrointestinal', value: 8 },
    9: { name: 'Genitourinary', value: 9 },
    10: { name: 'Endocrine', value: 10 },
    11: { name: 'Heme/Onc', value: 11 },
    12: { name: 'Infectious', value: 12 },
    13: { name: 'Musculoskeletal', value: 13 },
    14: { name: 'Skin', value: 14 },
    15: { name: 'Neurological', value: 15 },
    16: { name: 'Psychiatric', value: 16 },
    17: { name: 'None', value: 17 },
    18: { name: 'Miscellaneous', value: 18 },
  },
};

export const SocialHistoryCategory = {
  TOBACCO: 1,
  ALCOHOL: 2,
  DRUG: 3,
  CARDIO: 4,
  SAFETY: 5,
  SEXUAL: 6,
  GENDER: 7,
  NONE: 8,
  CUSTOM: 9,

  properties: {
    1: { name: 'Tobacco', value: 1 },
    2: { name: 'Alcohol', value: 2 },
    3: { name: 'Drug Abuse', value: 3 },
    4: { name: 'Cardiovascular', value: 4 },
    5: { name: 'Safety', value: 5 },
    6: { name: 'Sexual Activity', value: 6 },
    7: { name: 'Birth Gender', value: 7 },
    8: { name: 'None', value: 8 },
    9: { name: 'Miscellaneous', value: 9 },
  },
};

export const SurgicalHistoryCategory = {
  NONE: 1,
  CUSTOM: 2,

  properties: {
    1: { name: 'None', value: 1 },
    2: { name: 'Miscellaneous', value: 2 },
  },
};

export const medicalHistoryDataGroup1 = [
  {
    category: MedicalHistoryCategory.HEAD,
    items: [
      {
        label: 'Trauma',
        name: 'Trauma',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.EYES,
    items: [
      {
        label: 'Blindness',
        name: 'Blindness',
      },
      {
        label: 'Cataracts',
        name: 'Cataracts',
      },
      {
        label: 'Glaucoma',
        name: 'Glaucoma',
      },
      {
        label: 'Wears glasses/ contacts',
        name: 'Glasses',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.EARS,
    items: [
      {
        label: 'Hearing aids',
        name: 'Hearing-Aids',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.NOSE,
    items: [
      {
        label: 'Allergic Rhinitis',
        name: 'Allergic-Rhinitis',
      },
      {
        label: 'Sinus Infections',
        name: 'Sinus-Infections',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.MOUTH,
    items: [
      {
        label: 'Dentures',
        name: 'Dentures',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.CARDIO,
    items: [
      {
        label: 'Aneurysm',
        name: 'Aneurysm',
      },
      {
        label: 'Angina',
        name: 'Angina',
      },
      {
        label: 'DVT',
        name: 'DVT',
      },
      {
        label: 'Dysrhythmia',
        name: 'Dysrhythmia',
      },
      {
        label: 'HTN',
        name: 'HTN',
      },
      {
        label: 'Murmur',
        name: 'Murmur',
      },
      {
        label: 'Myocardial infarction',
        name: 'Myocardial',
      },
      {
        label: 'Other heart disease',
        name: 'Other-Heart',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.RESPI,
    items: [
      {
        label: 'Asthma',
        name: 'Asthma',
      },
      {
        label: 'Bronchitis',
        name: 'Bronchitis',
      },
      {
        label: 'COPD - Bronchitis/Emphysema',
        name: 'COPD',
      },
      {
        label: 'Pleuritis',
        name: 'Pleuritis',
      },
      {
        label: 'Pneumonia',
        name: 'Pneumonia',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.GASTRO,
    items: [
      {
        label: 'Cirrhosis',
        name: 'Cirrhosis',
      },
      {
        label: 'GERD',
        name: 'GERD',
      },
      {
        label: 'Gallbladder disease',
        name: 'Gallbladder-Disease',
      },
      {
        label: 'Heartburn',
        name: 'Heartburn',
      },
      {
        label: 'Hemorrhoids',
        name: 'Hemorrhoids',
      },
      {
        label: 'Hepatitis',
        name: 'Hepatitis',
      },
      {
        label: 'Hiatal hernia',
        name: 'Hiatal-Hernia',
      },
      {
        label: 'Jaundice',
        name: 'Jaundice',
      },
      {
        label: 'Ulcer',
        name: 'Ulcer',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.GENI,
    items: [
      {
        label: 'Hernia',
        name: 'Hernia',
      },
      {
        label: 'Incontinence',
        name: 'Incontinence',
      },
      {
        label: 'Nephrolithiasis',
        name: 'Nephrolithiasis',
      },
      {
        label: 'Other kidney disease',
        name: 'Other-Kidney',
      },
      {
        label: 'STDs',
        name: 'STDs',
      },
      {
        label: 'UTI(s)',
        name: 'UTIs',
      },
    ],
  },
];

export const medicalHistoryDataGroup2 = [
  {
    category: MedicalHistoryCategory.ENDO,
    items: [
      {
        label: 'Goiter',
        name: 'Goiter',
      },
      {
        label: 'Hyperlipidemia',
        name: 'Hyperlipidemia',
      },
      {
        label: 'Hypothyroidism',
        name: 'Hypothyroidism',
      },
      {
        label: 'Thyroid disease',
        name: 'Thyroid',
      },
      {
        label: 'Thyroiditis',
        name: 'Thyroiditis',
      },
      {
        label: 'Type 1 DM',
        name: 'Type1-DM',
      },
      {
        label: 'Type 2 DM',
        name: 'Type2-DM',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.HEME,
    items: [
      {
        label: 'Anemia',
        name: 'Anemia',
      },
      {
        label: 'Cancer',
        name: 'Cancer',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.INFECT,
    items: [
      {
        label: 'HIV',
        name: 'Hiv',
      },
      {
        label: 'STDs',
        name: 'Stds',
      },
      {
        label: 'Tuberculosis (dz)',
        name: 'Tuberculosis',
      },
      {
        label: 'Tuberculosis (exposure)',
        name: 'Tuberculosis-Exposure',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.MUSCU,
    items: [
      {
        label: 'Arthritis',
        name: 'Arthritis',
      },
      {
        label: 'Gout',
        name: 'Gout',
      },
      {
        label: 'M/S injury',
        name: 'MS-Injury',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.SKIN,
    items: [
      {
        label: 'Dermatitis',
        name: 'Dermatitis',
      },
      {
        label: 'Mole(s)',
        name: 'Moles',
      },
      {
        label: 'Other skin condition(s)',
        name: 'Other-Skin',
      },
      {
        label: 'Psoriasis',
        name: 'Psoriasis',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.NEURO,
    items: [
      {
        label: 'Epilepsy',
        name: 'Epilepsy',
      },
      {
        label: 'Seizures',
        name: 'Seizures',
      },
      {
        label: 'Severe headaches, migraines',
        name: 'Headaches',
      },
      {
        label: 'Stroke',
        name: 'Stroke',
      },
      {
        label: 'TIA',
        name: 'Tia',
      },
    ],
  },
  {
    category: MedicalHistoryCategory.PSYCH,
    items: [
      {
        label: 'Bipolar disorder',
        name: 'Bipolar',
      },
      {
        label: 'Depression',
        name: 'Depression',
      },
      {
        label: 'Hallucinations, delusions',
        name: 'Hallucinations',
      },
      {
        label: 'Suicidal ideation',
        name: 'Suicidal-Ideation',
      },
      {
        label: 'Suicide attempts',
        name: 'Suicide-Attempts',
      },
    ],
  },
];

export const socialHistoryDataGroup1 = [
  {
    category: SocialHistoryCategory.TOBACCO,
    items: [
      {
        label: 'Current every day smoker',
        name: 'Tobacco-Daily',
      },
      {
        label: 'Current some day smoker',
        name: 'Tobacco-SomeDay',
      },
      {
        label: 'Former smoker',
        name: 'Former-Smoker',
      },
      {
        label: 'Heavy tobacco smoker',
        name: 'Tobacco-Heavy',
      },
      {
        label: 'Light tobacco smoker',
        name: 'Tobacco-Light',
      },
      {
        label: 'Never smoked',
        name: 'Tobacco-Never',
      },
      {
        label: 'Smoker, current status unknown',
        name: 'Tobacco-CurrentUnknown',
      },
      {
        label: 'Unknown if ever smoked',
        name: 'Tobacco-Unknown',
      },
    ],
  },
  {
    category: SocialHistoryCategory.ALCOHOL,
    items: [
      {
        label: 'Do not drink',
        name: 'Alcohol-None',
      },
      {
        label: 'Drink Daily',
        name: 'Alcohol-Daily',
      },
      {
        label: 'Frequently Drink',
        name: 'Alcohol-Frequently',
      },
      {
        label: 'Hx of Alcoholism',
        name: 'Alcohol-Alcoholism',
      },
      {
        label: 'Occasional drink',
        name: 'Alcohol-Occasional',
      },
    ],
  },
  {
    category: SocialHistoryCategory.DRUG,
    items: [
      {
        label: 'IVDU',
        name: 'Drug-IVDU',
      },
      {
        label: 'Illicit drug use',
        name: 'Drug-Illicit',
      },
      {
        label: 'No illicit drug use',
        name: 'Drug-None',
      },
    ],
  },
];

export const socialHistoryDataGroup2 = [
  {
    category: SocialHistoryCategory.NONE,
    items: [
      {
        label: 'Traveled internationally',
        name: 'Traveled - internationally',
      },
    ],
  },
  {
    category: SocialHistoryCategory.CARDIO,
    items: [
      {
        label: 'Eat healthy meals',
        name: 'Cardio-Healthy',
      },
      {
        label: 'Regular exercise',
        name: 'Cardio-Exericse',
      },
      {
        label: 'Take daily asprin',
        name: 'Cardio-Asprin',
      },
    ],
  },
  {
    category: SocialHistoryCategory.SAFETY,
    items: [
      {
        label: 'Household Smoke detector',
        name: 'Safety-Smoke',
      },
      {
        label: 'Keep Firearms in home',
        name: 'Safety-Firearms',
      },
      {
        label: 'Wear seatbelts',
        name: 'Safety-Seatbelts',
      },
    ],
  },
  {
    category: SocialHistoryCategory.SEXUAL,
    items: [
      {
        label: 'Exposure to STI',
        name: 'Sexual-STI',
      },
      {
        label: 'Not sexually active',
        name: 'Sexual-Inactive',
      },
      {
        label: 'Safe sex practices',
        name: 'Sexual-Safe',
      },
      {
        label: 'Sexually Active',
        name: 'Sexual-Active',
      },
    ],
  },
  {
    category: SocialHistoryCategory.GENDER,
    items: [
      {
        label: 'Male',
        name: 'Gender-Male',
      },
      {
        label: 'Female',
        name: 'Gender-Female',
      },
      {
        label: 'Undifferentiated',
        name: 'Gender-Undifferentiated',
      },
    ],
  },
];

export const surgicalHistoryDataGroup1 = [
  {
    category: SurgicalHistoryCategory.NONE,
    items: [
      {
        label: 'Aneurysm repair',
        name: 'Aneurysm-Repair',
      },
      {
        label: 'Appendectomy',
        name: 'Appendectomy',
      },
      {
        label: 'Back surgery',
        name: 'Back-Surgery',
      },
      {
        label: 'Bariatric surgery/gastric bypass',
        name: 'Bariatric-Gastric',
      },
      {
        label: 'Bilateral tubal ligation',
        name: 'Bilateral-Tubal-Ligation',
      },
      {
        label: 'Breast resection/mastectomy',
        name: 'Breast-Resection',
      },
      {
        label: 'CABG',
        name: 'CABG',
      },
      {
        label: 'Carotid endarterectomy/stent',
        name: 'Carotid-endarterectomy',
      },
      {
        label: 'Carpal tunnel release surgery',
        name: 'Carpal-Tunnel-Release-Surgery',
      },
      {
        label: 'Cataract/lens surgery',
        name: 'Cataract-Surgery',
      },
      {
        label: 'Cesarean section',
        name: 'Cesarean-Section',
      },
      {
        label: 'Cholecystectomy/bile duct surgery',
        name: 'Cholecystectomy',
      },
      {
        label: 'Dilation and curettage',
        name: 'Dilation-Curettage',
      },
      {
        label: 'Hemorrhoid surgery',
        name: 'Hemorrhoid-Surgery',
      },
      {
        label: 'Hip arthroplasty',
        name: 'Hip-Arthroplasty',
      },
      {
        label: 'Hip replacement',
        name: 'Hip-Replacement',
      },
      {
        label: 'Hysterectomy',
        name: 'Hysterectomy',
      },
      {
        label: 'Inguinal hernia repair',
        name: 'Inguinal-Hernia-Repair',
      },
    ],
  },
];

export const surgicalHistoryDataGroup2 = [
  {
    category: SurgicalHistoryCategory.NONE,
    items: [
      {
        label: 'Knee arthroplasty',
        name: 'Knee-Arthroplasty',
      },
      {
        label: 'LASIK',
        name: 'LASIK',
      },
      {
        label: 'Laminectomy',
        name: 'Laminectomy',
      },
      {
        label: 'Nasal surgery',
        name: 'Nasal-Surgery',
      },
      {
        label: 'PTCA/PCI',
        name: 'PTCA',
      },
      {
        label: 'Pacemaker/defibrillator',
        name: 'Pacemaker',
      },
      {
        label: 'Prostate surgery',
        name: 'Prostate',
      },
      {
        label: 'Prostatectomy',
        name: 'Prostatectomy',
      },
      {
        label: 'Rotator cuff surgery',
        name: 'Rotator-Cuff-Surgery',
      },
      {
        label: 'Sinus surgery',
        name: 'Sinus-Surgery',
      },
      {
        label: 'Skin cancer excision',
        name: 'Skin-Cancer-Excision',
      },
      {
        label: 'Spinal fusion',
        name: 'Spinal-Fusion',
      },
      {
        label: 'TAH-BSO',
        name: 'TAH-BSO',
      },
      {
        label: 'TURP',
        name: 'TURP',
      },
      {
        label: 'Tonsillectomy/Adenoidectomy',
        name: 'Tonsillectomy',
      },
      {
        label: 'Vasectomy',
        name: 'Vasectomy',
      },
    ],
  },
];
